<script setup>
// On a volunteer's own page: tells this browser that its visitor is the volunteer, so that the event's page
// greets them with their next shifts (event-volunteer-finder.vue).
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { forgetVolunteer, readRememberedVolunteer, rememberVolunteer } from '../modules/remembered-volunteer'

const props = defineProps({
  eventId: String,
  volunteerId: Number,
  volunteerName: String,
})

const { t } = useI18n()

const remembered = ref(readRememberedVolunteer(props.eventId)?.id === props.volunteerId)

function remember() {
  remembered.value = rememberVolunteer(props.eventId, { id: props.volunteerId, name: props.volunteerName })
}

function forget() {
  forgetVolunteer(props.eventId)
  remembered.value = false
}
</script>

<template>
  <button v-if="remembered" type="button" class="btn btn-sm btn-secondary" :title="t('volunteer_remember.forget')" @click="forget">
    <span class="bi bi-person-check-fill me-1"></span>
    {{ t('volunteer_remember.remembered') }}
  </button>
  <button v-else type="button" class="btn btn-sm btn-outline-secondary" :title="t('volunteer_remember.hint')" @click="remember">
    <span class="bi bi-person-check me-1"></span>
    {{ t('volunteer_remember.remember') }}
  </button>
</template>
